<div class="tab active">
    <div class="scrollable-content">
        <ng-component *ngIf="!objectKeys(nodes).length">Please add slings to the site.</ng-component>
        <div class="middle-box-holder lift-boxes" *ngIf="nodes">
            <status-component *ngFor="let key of objectKeys(nodes)" [node]="nodes[key]"></status-component>
        </div>
    </div>
</div>
